<template>
  <div>
    <div class="menu">
      <div class="logo-box">
        <img src="../assets/logo.png" class="logo" />
        <p>HappyCredito</p>
      </div>
      <div class="menu-box">
        <div class="list">
          <div :class="step == 1 ? 'select' : ''" @click="selectMenu(1)">
            Recomendaciones financieras
          </div>
          <div :class="step == 2 ? 'select' : ''" @click="selectMenu(2)">
            Seguridad financiera
          </div>
          <div :class="step == 3 ? 'select' : ''" @click="selectMenu(3)">
            Política de privacidad
          </div>
          <div :class="step == 5 ? 'select' : ''" @click="selectMenu(5)">
            Contáctenos
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
export default {
  name: "Menu",
  props: {
    step: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      index: 0,
    };
  },
  methods: {
    selectMenu(value) {
      this.index = value;
      if (value == this.step) {
        return;
      }
      switch (value) {
        case 1:
          this.$router.push({ path: "/" });
          break;
        case 2:
          this.$router.push({ path: "about" });
          break;
        case 3:
          this.$router.push({ path: "services" });
          break;
        case 4:
          this.$router.push({ path: "offers" });
          break;
        case 5:
          this.$router.push({ path: "contact" });
          break;
        // case 5: this.$router.push({ path: "cooperate" }); break;
        default:
          this.$router.push({ path: "/" });
          break;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.menu {
  padding: 0 360px;
  display: flex;
  justify-content: space-between;

  .logo-box {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    .logo {
      // width: 64px;
      height: 36px;
      margin-right: 14px;
    }

    p {
      font-family: Paytone One, Paytone One;
      font-weight: 600;
      font-size: 28px;
      color: #fff;
      margin-left: 10px;
    }
  }
}

.menu-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 80px;

  cursor: pointer;

  .list {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .select {
      color: #fff;
      background: #EAB308;
      color: #282D3D;
    }

    div {
      font-weight: 400;
      font-size: 16px;
      padding: 0 30px;
      color: #fff;
      border-radius: 19px;
      padding: 5px 15px;
    }
  }

  .btn {
    width: 112px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #ffd808;
    font-family: Roboto, Roboto;
    font-weight: 500;
    font-size: 16px;
    border-radius: 4px 4px 4px 4px;
    color: #333;
    margin-right: 40px;
  }
}
</style>